import angular from 'angular';
import CategoryPagerToolboxDirective from './category-pager-toolbox.directive';

let CategoryPagerToolboxModule = angular.module('catalog.category.categoryPagerToolbox', [])
  .directive('categoryPagerToolbox', CategoryPagerToolboxDirective);

export default CategoryPagerToolboxModule;




/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.js
 **/